import type { Step } from "react-joyride";

export const otRulesTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຂໍ້ກຳນົດ OT. ຈັດການການຕັ້ງຄ່າອັດຕາຄູນ OT ຕາມປະເພດວັນ (ວັນທຳມະດາ / ວັນພັກ) ເພື່ອຄິດເງິນເດືອນທີ່ຖືກຕ້ອງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-rules-toolbar"]',
    content:
      "ສ້າງຂໍ້ກຳນົດ OT ໃໝ່ ຫຼື ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-rules-filter"]',
    content: "ກັ່ນຕອງຕາມປະເພດວັນ (ວັນທຳມະດາ/ວັນພັກ), ສະຖານະ (ໃຊ້ງານ/ປິດ) ແລະ ຄົ້ນຫາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-rules-table"]',
    content:
      "ຕາຕະລາງຂໍ້ກຳນົດ OT. ກົດແຖວເພື່ອເບິ່ງລາຍລະອຽດ ຫຼື ແກ້ໄຂ.",
    placement: "top",
  },
];
